module.exports = __webpack_public_path__ + "img/1588178369.37912d70.jpg";